@if (gotPrerequisites()) {
    <div
        id="{{widgetId}}"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition">
        <form
            name="printAreaForm"
            novalidate
            autocomplete="off">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>{{widgetConfig.header}}</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="helpLinkUrl"
                        [pageTitle]="helpPageTitle"></nlrp-help-link>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        title="{{widgetConfig.closeTooltip}}"
                        id="closePrintAreaBtn"
                        (click)="onClickCancel()"></i>
                </div>
            </div>
            <div class="widget-content">
                <div class="col-xs-12">
                    <label class="control-label">Paper size</label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': paperSize | formFieldHasError}">
                        <ng-select
                            class="nlr-ng-select"
                            [searchable]="false"
                            [clearable]="false"
                            name="paperSize"
                            id="paperSize"
                            required
                            title="Select the paper size"
                            placeholder="Select"
                            [items]="getPaperSizeLookups()"
                            bindLabel="paperSize"
                            bindValue="id"
                            [(ngModel)]="paperSizeId"
                            (change)="paperSizeChanged()"
                            #paperSize="ngModel">
                        </ng-select>
                    </div>
                </div>
                <div class="col-xs-12">
                    <label class="control-label">Scale</label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': referenceScale | formFieldHasError}">
                        <ng-select
                            class="nlr-ng-select"
                            [searchable]="false"
                            [clearable]="false"
                            [disabled]="isReferenceScaleDisabled()"
                            name="referenceScale"
                            id="referenceScale"
                            required
                            title="Select the reference scale"
                            placeholder="Select"
                            [items]="getReferenceScaleLookups()"
                            bindLabel="referenceScale"
                            bindValue="id"
                            [(ngModel)]="referenceScaleId"
                            (change)="referenceScaleChanged()"
                            #referenceScale="ngModel">
                        </ng-select>
                    </div>
                </div>
                <div>
                    <button
                        id="applyPrintAreaBtn"
                        class="btn btn-default nlr-btn-sm"
                        title="Apply"
                        (click)="onClickApply()">
                        Apply
                    </button>
                    <button
                        class="btn btn-warning nlr-btn-sm"
                        title="Close"
                        id="cancelPrintAreaBtn"
                        (click)="onClickCancel()">
                        Close
                    </button>
                </div>
            </div>
        </form>
    </div>
}
